if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
  evt.preventDefault();

  if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

  this.handleErrorMessage();

  const variantIdInput = this.variantIdInput;

  if (!variantIdInput || !variantIdInput.value) {
    this.handleErrorMessage('Please select a size and color.');
    return;
  }

  this.submitButton.setAttribute('aria-disabled', true);
  this.submitButton.classList.add('loading');

  const spinner = this.querySelector('.loading__spinner');

  if (spinner) {
    spinner.classList.remove('hidden');
  }

  const config = fetchConfig('javascript');

  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData(this.form);

  formData.set('id', variantIdInput.value);

  if (!formData.get('quantity')) {
    formData.set('quantity', '1');
  }

  if (this.cart) {
    const sections = this.cart
      .getSectionsToRender()
      .map((section) => section.id)
      .filter(Boolean);

    if (sections.length) {
      formData.append('sections', sections.join(','));
      formData.append('sections_url', window.location.pathname);
    }

    this.cart.setActiveElement(document.activeElement);
  }

  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {

      if (response.status) {

        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: variantIdInput.value,
          errors: response.errors || response.description,
          message: response.message,
        });

        this.handleErrorMessage(
          response.description || 'Unable to add this product to cart.'
        );

        const soldOutMessage =
          this.submitButton.querySelector('.sold-out-message');

        if (soldOutMessage) {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButtonText.classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
        }

        this.error = true;
        return;
      }

      if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }

      const startMarker =
        CartPerformance.createStartingMarker(
          'add:wait-for-subscribers'
        );

      if (!this.error) {

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: variantIdInput.value,
          cartData: response,
        }).then(() => {

          CartPerformance.measureFromMarker(
            'add:wait-for-subscribers',
            startMarker
          );

        });

      }

      this.error = false;

      const quickAddModal = this.closest('quick-add-modal');

      if (quickAddModal) {

        document.body.addEventListener(
          'modalClosed',
          () => {

            setTimeout(() => {

              CartPerformance.measure(
                'add:paint-updated-sections',
                () => {
                  this.cart.renderContents(response);
                }
              );

            });

          },
          { once: true }
        );

        quickAddModal.hide(true);

      } else {

        CartPerformance.measure(
          'add:paint-updated-sections',
          () => {
            this.cart.renderContents(response);
          }
        );

      }

    })
    .catch((e) => {

      console.error('Add to cart error:', e);

      this.handleErrorMessage(
        'Something went wrong. Please try again.'
      );

    })
    .finally(() => {

      this.submitButton.classList.remove('loading');

      if (
        this.cart &&
        this.cart.classList.contains('is-empty')
      ) {
        this.cart.classList.remove('is-empty');
      }

      if (!this.error) {
        this.submitButton.removeAttribute('aria-disabled');
      }

      if (spinner) {
        spinner.classList.add('hidden');
      }

      CartPerformance.measureFromEvent(
        'add:user-action',
        evt
      );

    });
}

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
  if (disable) {
    this.submitButton.setAttribute('disabled', 'disabled');

    if (text) {
      this.submitButtonText.textContent = text;
    }

  } else {
    // Enable the button
    this.submitButton.removeAttribute('disabled');

    // IMPORTANT:
    // Remove the state that was set after an out-of-stock error
    this.submitButton.removeAttribute('aria-disabled');

    // Reset the product form error state
    this.error = false;

    // Restore normal Add to Cart text
    this.submitButtonText.classList.remove('hidden');
    this.submitButtonText.textContent = window.variantStrings.addToCart;

    // Hide Sold Out message if it was previously displayed
    const soldOutMessage =
      this.submitButton.querySelector('.sold-out-message');

    if (soldOutMessage) {
      soldOutMessage.classList.add('hidden');
    }
  }
}

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
